export function generateMenuItems(userDetails, pathname, params, icons) {
  const { icon3, icon4, icon5, icon6, icon7, icon8, icon9, icon10 } = icons;

  const menuItems = [
    {
      icon: icon3,
      label: "Finance",
      path:
        userDetails?.user_category === "Finance"
          ? "/ayekart-fintech/finance-grids"
          : "/ayekart-fintech/orders",
      isActive: [
        "/ayekart-fintech/finance-grids",
        "/ayekart-fintech/orders",
        "/operations/grid-view",
      ].some((path) => pathname.includes(path)),
      visible: ["Finance", "Operations"].includes(userDetails?.user_category),
      subItems: [
        {
          label: "Ayekart Fintech",
          subItems: [
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Order Grids"
                  : "Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-fintech/finance-grids"
                  : "/ayekart-fintech/orders",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Limit breached Grids"
                  : "Orders (Limit breached)",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-fintech/limit-breached-grids"
                  : "/ayekart-fintech/orders-with-limit-breached",
                  
            },
          ],
        },
        {
          label: "Ayekart Agro",
          subItems: [
            {
              label:
                userDetails?.user_category === "Finance" ? "Orders Grids" : "Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-agro/finance-grids"
                  : "/ayekart-agro/orders",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Limit breached Grids"
                  : "Orders (Limit Breached)",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-agro/limit-breached-grids"
                  : "/ayekart-agro/orders-with-limit-breached",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "FNV Grids"
                  : "FNV Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-agro/fnv/finance-grids"
                  : "/ayekart-agro/fnv/orders",
            },
             
          ],
        },
        {
          label: "Ayekart Retail",
          subItems: [
            {
              label:
                userDetails?.user_category === "Finance" ? "Orders Grids" : "Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-retail/finance-grids"
                  : "/ayekart-retail/orders",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Limit breached Grids"
                  : "Orders (Limit Breached)",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-retail/limit-breached-grids"
                  : "/ayekart-retail/orders-with-limit-breached",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Advance WD Grids"
                  : "Advance WD Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-retail/advance-wholesale-distribution/finance-grids"
                  : "/ayekart-retail/advance-wholesale-distribution",
            },
            {
              label:
                userDetails?.user_category === "Finance"
                  ? "Advance PO Grids"
                  : "Advance PO Orders",
              path:
                userDetails?.user_category === "Finance"
                  ? "/ayekart-retail/advance-PO/finance-grids"
                  : "/ayekart-retail/advance-PO",
            },
          ],
        },
         
      ],
    },

    {
      icon: icon4,
      label: "Pre-Order",
      path: "/pre-order-list",
      isActive:
        ["/pre-order-list", "/pre-order-list/Upload"].includes(pathname) ||
        Boolean(params?.batch_id),
      visible: userDetails?.user_category !== "Finance",
    },
    {
      icon: icon5,
      label: "e-Collection",
      path: "/settlement-tracker",
      isActive: ["/settlement-tracker", "/revoke-tracker"].includes(pathname),
      visible: userDetails?.user_category !== "Finance",
    },
    {
      icon: icon6,
      label: "Milk e-Collection",
      path: "/settlement-milk-tracker",
      isActive: pathname === "/settlement-milk-tracker",
      visible: userDetails?.user_category !== "Finance",
    },
    {
      icon: icon7,
      label: "DLR",
      path: "/distributors-lead-retail",
      isActive: pathname.includes("/distributors-lead-retail"),
      visible: userDetails?.user_category !== "Finance",
    },
    {
      icon: icon8,
      label: "Platform Charges",
      path: "/Operations/platform-charges",
      isActive: pathname === "/Operations/platform-charges",
      visible: ["Operations", "Finance"].includes(userDetails?.user_category),
    },
    {
      icon: icon10,
      label: "Provisions",
      path: "/finance-provisions",
      isActive: pathname === "/finance-provisions",
      visible: userDetails?.user_category !== "Operations",
    },
    {
      icon: icon9,
      label: "Edit Provisions",
      path: "/edit-finance-provision",
      isActive: pathname === "/edit-finance-provision",
      visible: userDetails?.user_category !== "Operations",
    },
  ];

  return menuItems;
}

export function restrictedUser() {
  // return true/false based on user category or readonly email IDs
  const userDetails = JSON.parse(localStorage.getItem("user_detail") || "{}");
  const restrictedEmails = [
    "financereadonly@ayekart.com",
    "opsreadonly@ayekart.com",
  ];

  return (
    restrictedEmails?.includes((userDetails?.email_address || "").toLowerCase())
  );
}
